export const colors = {
  green: '#4fd975',
  red: '#f56570',
  gray: '#EBECF4',
  yellow: '#ffa700',
  orange_1: '#ff8900',
  orange_2: '#ffa700',
  orange_3: '#ffbe43',
  orange_4: '#fccf79',
  orange_5: '#fde1ab',
}

export const tabs = {
  DeliveryRate: 'Delivery Rate',
  UserReaction: 'User Reaction',
  'Listen(TTS)': 'Listen (TTS)',
  MediaOpened: 'Media Opened',
  ViewRate: 'View Rate',
  MarkedAsInappropriate: 'Marked as Inappropriate',
}

export const flagsName = {
  SexualContent: '1',
  'Violent or repulsive\ncontent': '2',
  'Hateful or abusive\ncontent': '3',
  'Harmful or\ndangerous acts': '4',
  'Spam or misleading': '5',
}

export const LIKES = 'likes'
export const REPORTS = 'reports'
export const SEXUAL_CONTENT = 'SexualContent'
export const LIKED = 'liked'
export const DIDNTlIKE = 'didntLike'
export const RECEIVED = 'received'
export const NOTRECEIVE = 'notReceived'
export const FEEDREAD = 'feedRead'
export const READ = 'read'
export const DIDNTREAD = 'didntRead'
export const FULL_LISTENED = 'fullListened'
export const LISTENED = 'listened'
export const DIDNT_LISTENED = 'didntListened'
export const OPENED = 'opened'
export const DIDNT_OPEN = 'didntOpen'
export const DELIVER = 'deliver'
export const REACTION = 'reaction'
export const SOCIAL_MEDIA_INTERACTIONS = 'socialMediaInteractions'
export const APP = 'app'
export const EMAIL = 'email'
export const SMS = 'sms'
export const AUTOMATE_CALL = 'automated'
export const CHANNEL_APP_TEXT = 'App'
export const CHANNEL_EMAIL_TEXT = 'Email'
export const CHANNEL_SMS_TEXT = 'SMS'
export const CHANNEL_AUTOMATE_CALL = 'Automated Call'
